export const DEPOSIT_PRODUCT = 'deposits';

export const PRODUCT_COLORS = {
    [DEPOSIT_PRODUCT]: ['#eaf9fb', '#cce8f0', '#afdff9'],
    default: '#e1e1f3',
}
